import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../../styles//form.css';
import '../../styles/botones_dflt.css';
import Spinner from "../spinner";
import {cargarClientes} from '../../services/apiClientes.js';
import {cargarRamos} from '../../services/apiRamos.js';
import {cargarCompanias} from '../../services/apiCompanias.js';
import {crearPoliza , actualizarPoliza , obtenerPoliza } from '../../services/apiPolizas.js';
import {convertirFechaParaInputDate} from '../../functions/fileFunctions.js';
import Siniestros from './crud_SINIESTROS.js';
import DocPolizas from './crud_DOC_POLIZAS.js';
import * as alerts from '../../functions/alerts.js';


const FormPolizas = () => {
const { id } = useParams();
  const [loading, setLoading] = useState(true);
  //const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [formData, setFormData] = useState({ numero: '', cliente: '' ,compania: -1, valor: '' ,ramo: -1, fechaEmision: '' ,fechaVencimiento: '', valorPrima: '' ,porcentaje: ''}); // Estado del formulario
  const [isEditing, setIsEditing] = useState(false); // Estado para editar
  const [optClientes, setOptClientes] = useState([]);
  const [optCompanias, setOptCompanias] = useState([]);
  const [optRamos, setOptRamos] = useState([]);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const irAFormulario = (id) => { navigate(`/formulario_polizas/${id}`); };
  const irAReporte = () => { navigate(`/polizas`); };

  const cargar_Ramos = useCallback (async (compania) => {
    try {
        if (compania) {
            const jsonRamos = await cargarRamos(compania);
            const ramosData = jsonRamos.ramos.map((item) => ({
                id: item.id,
                compania: item.compania,
                nombre: item.nombre,
            }));
            setOptRamos(ramosData);
        } else {
            setOptRamos([]);
        }
    } catch (error) {
        console.error('Error cargando las listas:', error);
    }
  },[]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const jsonClientes = await cargarClientes({});
        const clientesData = jsonClientes.clientes.map((item) => ({
          id: item.id,
          nombre: item.nombre,
          apellido: item.apellido,
          identificacion: item.cedula_ruc,
          direccion: item.direccion
        }));
        const jsonCompanias = await cargarCompanias();
        const companiasData = jsonCompanias.companias.map((item) => ({
            id: item.id,
            nombre: item.nombre,
            ruc: item.ruc,
            direccion: item.direccion,
        }));
        setOptClientes(clientesData);
        setOptCompanias(companiasData);
        if(!isEditing){  
          setLoading(false);
        }
      } catch (error) {
        console.error('Error cargando las listas:', error);
      }
    };

    const obtener_Poliza = async () => {
      try{
          const jsonPoliza = await obtenerPoliza(id);
          if(jsonPoliza){
            const formattedData = ({
              numero: jsonPoliza.numero,
              cliente: jsonPoliza.cliente,
              compania: jsonPoliza.compania,
              valor: jsonPoliza.valor,
              ramo: jsonPoliza.ramo,
              fechaEmision: convertirFechaParaInputDate(jsonPoliza.fechaEmision),
              fechaVencimiento: convertirFechaParaInputDate(jsonPoliza.fechaVencimiento),
              valorPrima: jsonPoliza.valorPrima,
              porcentaje: jsonPoliza.porcentaje
            });
            cargar_Ramos(jsonPoliza.compania);
            setFormData(formattedData);
          }
      } catch (error) {
        console.error('Error cargando las listas:', error);
      } 
    };


    if (id) {
          fetchData();
      if (id && id !== '-1') { 
        setIsEditing(true);
        obtener_Poliza();
      } else {
        setIsEditing(false);
      }
    }

  },[id, isEditing, cargar_Ramos]);
    

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === 'compania') {
      setOptRamos([]);
      cargar_Ramos(value);
    }
  };

  async function handleFormSubmit(e) {
      e.preventDefault();
      if (isEditing) {
        try {
          console.log(formData);
          const response = await actualizarPoliza(formData, storedUser, id);
          if (response.ok) {
            alerts.handleSuccess('Éxito!','Cambios guardados correctamente')
          } else {
            console.error('Error al guardar cambios:', response.statusText);
          }
        } catch (error) {
          console.error('Error al hacer la solicitud:', error);
        }
      } else {
        const response = await crearPoliza(formData , storedUser);
        if (response.ok) {
          const data = await response.json();
          const nuevaPoliza=data.poliza_id;
          alerts.handleSuccess('Éxito!','Póliza creada correctamente')
          irAFormulario(nuevaPoliza);
        } else {
          console.error('Error al agregar nueva póliza:', response.statusText);
        }
      }
    }

  return (
          <>
            {loading ? (<div className="spinner-container"> <Spinner /> </div> ) : (
              <>
                <div className="crud-table-form">
                <h2>{isEditing ? 'Editar Póliza' : 'Añadir Póliza'}</h2>
                <button type="submit" className='button guardar' onClick={handleFormSubmit}>{isEditing ? 'Actualizar' : 'Añadir'}</button>
                <button type="button" className='button cancelar' onClick={irAReporte}>Cancelar</button>
                <table>
                  <tbody>
                    <tr>
                      <td className='form-content'>
                        <h3>Información General</h3>
                        <form /*onSubmit={handleFormSubmit}*/ className='form_crud'>
                                <div className='header-label'>
                                <label htmlFor="numero">Número Póliza</label>
                                <input
                                    type="text"
                                    name="numero"
                                    placeholder="Número Póliza"
                                    value={formData.numero}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                                <div className='header-label'>
                                <label htmlFor="cliente">Cliente</label>
                                <select name="cliente" onChange={handleChange} value={formData.cliente}>
                                    <option key='-1' value='-1'>--Seleccione un Cliente--</option>
                                    {optClientes.map(opt => (
                                    <option key={opt.id} value={opt.id}>{opt.nombre+' '+opt.apellido+' - '+opt.identificacion}</option>
                                    ))}
                                </select>
                                </div>
                                <div className='container'>
                                  <div className='header-label'>
                                  <label htmlFor="compania">Compañía</label>
                                  <select name="compania" onChange={handleChange} value={formData.compania}>
                                          <option key='-1' value='-1'>--Seleccione una Compañía--</option>
                                      {optCompanias.map(opt => (
                                          <option key={opt.id} value={opt.id}>{opt.nombre+' - '+opt.ruc}</option>
                                      ))}
                                  </select>
                                  </div>
                                  <div className='header-label'>
                                  <label htmlFor="ramo">Ramo</label>
                                  <select name="ramo" onChange={handleChange} value={formData.ramo}>
                                          <option key='-1' value='-1'>--Seleccione un Ramo--</option>
                                      {optRamos.map(opt => (
                                          <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                                      ))}
                                  </select>
                                  </div>
                                </div>
                                <div className='container'>
                                  <div className='header-label'>
                                  <label htmlFor="fechaEmision">Fecha de Emisión</label>
                                  <input
                                      type="date"
                                      name="fechaEmision"
                                      placeholder="Fecha de Emisión"
                                      value={formData.fechaEmision}
                                      onChange={handleChange}
                                      required
                                  />
                                  </div>
                                  <div className='header-label'>
                                  <label htmlFor="fechaVencimiento">Fecha de Vencimiento</label>
                                  <input
                                      type="date"
                                      name="fechaVencimiento"
                                      placeholder="Fecha de Vencimiento"
                                      value={formData.fechaVencimiento}
                                      onChange={handleChange}
                                      required
                                  />
                                  </div>
                                </div>
                                <div className='container'>
                                <div className='header-label'>
                                <label htmlFor="valor">Valor Prima Neta</label>
                                <input
                                    type="number"
                                    name="valor"
                                    placeholder="Valor"
                                    value={formData.valor}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                                <div className='header-label'>
                                <label htmlFor="valorPrima">Valor Prima Total</label>
                                <input
                                    type="number"
                                    name="valorPrima"
                                    placeholder="Valor de Prima"
                                    value={formData.valorPrima}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                                <div className='header-label'>
                                <label htmlFor="porcentaje">Porcentaje Comisión</label>
                                <input
                                    type="number"
                                    name="porcentaje"
                                    placeholder="Porcentaje"
                                    value={formData.porcentaje}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                                </div>
                          </form>
                       </td>
                      </tr>
                     </tbody>
                    </table>
                  </div>    
                  {isEditing && (<div> <Siniestros polizaId={id}/>  <DocPolizas polizaId={id}/> </div>)}
                </>
              )}
            </>
          )};

export default FormPolizas;